import { Controller } from "stimulus";

// Mesa conversation composer: channel picker and internal-note toggle. Internal notes are staff-only,
// so the channel bar is replaced by a hint and the box turns amber. Outside the WhatsApp 24-hour
// window (templateRequired) free text and Send stay off: the "Selecionar template" button opens the
// template modal, which sends by itself. A session-based number whose session closed (senderBlocked)
// keeps them off the same way until it reconnects. The Send button holds more than its text (the
// shortcut hint of submit-shortcut), so only the label inside it changes with the note, to one of
// the two translated texts the view hands over.
export default class extends Controller {
  static targets = ["box", "channel", "noteField", "chanpick", "replyHint", "noteHint", "noteToggle", "send", "sendLabel", "windowHint", "pickButton", "textarea"];
  static values = { templateRequired: Boolean, senderBlocked: Boolean, sendLabel: String, noteLabel: String };

  connect() {
    this.refreshSend();
  }

  pickChannel(event) {
    const channel = event.currentTarget.dataset.channel;
    this.channelTarget.value = channel;
    this.chanpickTargets.forEach((btn) => btn.classList.toggle("is-on", btn.dataset.channel === channel));
    this.syncWhatsappControls();
  }

  toggleNote() {
    const isNote = this.noteFieldTarget.value !== "true";
    this.noteFieldTarget.value = isNote ? "true" : "false";

    this.element.classList.toggle("is-note", isNote);
    this.noteToggleTarget.classList.toggle("is-on", isNote);
    this.replyHintTarget.hidden = isNote;
    this.chanpickTargets.forEach((btn) => (btn.hidden = isNote));
    this.noteHintTarget.hidden = !isNote;

    this.sendLabelTarget.textContent = isNote ? this.noteLabelValue : this.sendLabelValue;
    this.sendTarget.classList.toggle("note", isNote);
    this.syncWhatsappControls();
  }

  refreshSend() {
    this.sendTarget.disabled = !this.isNote() && this.onWhatsapp() && this.whatsappBlocked();
  }

  syncWhatsappControls() {
    const show = this.onWhatsapp() && !this.isNote();
    if (this.hasPickButtonTarget) this.pickButtonTarget.hidden = !show;
    if (this.hasWindowHintTarget) this.windowHintTarget.hidden = !show;
    if (this.hasTextareaTarget) this.textareaTarget.disabled = show && this.whatsappBlocked();
    this.refreshSend();
  }

  whatsappBlocked() {
    return this.templateRequiredValue || this.senderBlockedValue;
  }

  onWhatsapp() {
    return this.channelTarget.value === "whatsapp";
  }

  isNote() {
    return this.noteFieldTarget.value === "true";
  }
}
